import React from 'react';
import WhiteList from "../components/WhiteList";
import useWhiteList from "../hook/useWhiteList";

const WhiteListPage = () => {
    const whitelist = useWhiteList();
    return <WhiteList {...whitelist} />;
}

export default WhiteListPage;
